const selectAll = 'Select all that apply';
const overallAmount = 'Overall:';
const howMuch = 'Amount:';
const howMuchSaved = 'Saved:';
const whenYouNeed = 'When:';
const amountToBorrow = 'How much do you need?';
const amountSaved = 'How much have you saved';
const access = 'Access:';
const welcome = 'Welcome';
const next = 'Next';
const goBack = 'Back';
const weekly = 'Weekly';
const quarterly = 'Quarterly';
const monthly = 'Monthly';
const yearly = 'Yearly';
const yearlyPlus = '> Year';
const loanTiming = 'When do you need the money?';
const upFront = 'One lump sum';
const overTime = 'Repeatable access over time';

export default {
  /**
   * ============================
   * GENERAL MESSAGES
   * ============================
   */

  'summary.getStarted': 'Contact Me',

  'contactFormSubmitted.success.title': 'Form submitted',
  'contactFormSubmitted.success.message': 'A Hancock Whitney Banker will contact you soon and an email will be sent to you with a link to your recommendations.',

  'summary.steps.title': 'Next Steps',
  'summary.steps.subtitle': 'Have a banker contact you with more information on these products and services, or get started by applying for select accounts online today',
  'summary.steps.contact': 'Or visit a <href>https://locations.hancockwhitney.com||financial center</href> to learn more about these accounts',
  'summary.actions.email': 'Email me my recommendations',
  'summary.applyNow': 'Apply Now',

  /**
   * ============================
   * QUESTION MESSAGES
   * ============================
   */

  /* ENTRY Question 1.1 */
  'productTypePreference': 'How may we assist you today?',
  'productTypePreference.subtext': selectAll,
  'productTypePreference.checking': 'Find the Checking Account that is right for me',
  'productTypePreference.checking.icon': '/classpath/assets/images/icon-review.svg',
  'productTypePreference.savings': 'Discover which savings products meet my needs',
  'productTypePreference.savings.icon': '/classpath/assets/images/icon-creditcard.svg',
  'productTypePreference.borrow': 'Determine best option(s) for my borrowing needs',
  'productTypePreference.borrow.icon': '/classpath/assets/images/icon-check.svg',
  'productTypePreference.minor': 'I am a minor looking to open a deposit account',
  'productTypePreference.minor.icon': '/classpath/assets/images/icon-graduation-hat-1.svg',
  'productTypePreference.overdraft': 'Understanding my overdraft protection options',
  'productTypePreference.overdraft.icon': '/classpath/assets/images/icon-lock.svg',

  /* ENTRY Question 1.2 */
  'customerReferral': 'What made you visit our website today?',
  'customerReferral.subtext': selectAll,
  'customerReferral.customer': 'Current Client',
  'customerReferral.digital': 'Digital Advertisement',
  'customerReferral.print': 'Print Advertisement',
  'customerReferral.referred': 'Referred by Friend / Family',
  'customerReferral.other': 'Other',

  /* DEPOSIT Question 2.1 */
  'wantAccountFeature': 'Which statement most accurately represents what you want from a checking account?',
  'wantAccountFeature.noFrills': 'I want a simple account that doesn\'t charge Overdraft Fees.',
  'wantAccountFeature.enhanced': 'I want a flexible, everyday account with a monthly service charge that\'s easy to waive.',
  'wantAccountFeature.best': 'I want an interest bearing account with extra features, like free ATM withdrawals and other priority services.',
  'wantAccountFeature.none': 'None of the above',

  /* DEPOSIT Question 2.2 */
  'paymentMethods': 'How do you pay for your expenses?',
  'paymentMethods.subtext': selectAll,
  'paymentMethods.tooltip': '(Rent, Car, Insurance, Utilities, etc.)',
  'paymentMethods.checking': 'Auto-Deduct from Checking',
  'paymentMethods.cash': 'Cash',
  'paymentMethods.check': 'Check',
  'paymentMethods.credit': 'Credit Card',
  'paymentMethods.debit': 'Debit Card',
  'paymentMethods.online': 'Online Bill Pay',
  'paymentMethods.electronic': 'Electronic Payments (i.e., Android Pay, Apple Pay, Zelle)',

  /* DEPOSIT Question 2.3 (ONLINE) 2.4 (BRANCH) */
    /* START CHECKING */
    'checking.cardBuilder.title': '<h4>Checking Account</h4>',
    'checkingBalance': 'Overall Checking Balance:',
    'details.checkingBalance': `Checking balance | ${ overallAmount }`,
    'checkingBalance.cardBuilder.answerLabel': overallAmount,
    /* END CHECKING */
    /* START SAVINGS */
    'savings.cardBuilder.title': 'Savings Account <small>(include money market accounts)</small>',
    'savingsBalance': 'Overall Savings Balance:',
    'details.savingsBalance': `Savings Balance | ${ overallAmount }`,
    'savingsBalance.cardBuilder.answerLabel': overallAmount,
    /* END SAVINGS */
    /* START CD */
    'cd.cardBuilder.title': '<h4>CD Account</h4>',
    'cdBalance': 'Overall CD Balance:',
    'details.cdBalance': `CD Balance | ${ overallAmount }`,
    'cdBalance.cardBuilder.answerLabel': overallAmount,
    /* END CD */
    /* START RETIREMENT */
    'retirement.cardBuilder.title': 'Retirement Account <small>(include IRAs, 401K, etc.)</small>',
    'retirementBalance': 'Overall Retirement balance:',
    'details.retirementBalance': `Retirement balance | ${ overallAmount }`,
    'retirementBalance.cardBuilder.answerLabel': overallAmount,
    /* END RETIREMENT */

    /* START OTHER */
    'other.cardBuilder.title': 'Other Account <small>(include IRAs, 401K, etc.)</small>',
    'otherBalance': 'Overall Other balance:',
    'details.otherBalance': `Other balance | ${ overallAmount }`,
    'otherBalance.cardBuilder.answerLabel': overallAmount,
    /* END OTHER */
  /* END DEPOSIT Question */

  /* DEPOSIT Question 2.4 */
  'savingsGoalTypes.savingsUnexpectedGoal': 'Emergency / Unexpected Expense',
  'savingsGoalTypes.savingsUnexpectedGoal.image': '/classpath/assets/images/icon-unexpected.svg',
  'savingsGoalTypes.savingsUnexpectedGoal.title': 'Emergency / Unexpected Expense',
  'savingsGoalTypes.savingsMajorGoal': 'Major purchase / Vacation / Education',
  'savingsGoalTypes.savingsMajorGoal.image': '/classpath/assets/images/icon-majorPurchase.svg',
  'savingsGoalTypes.savingsMajorGoal.title': 'Major purchase / Vacation / Education',
  'savingsGoalTypes.savingsHolidayGoal': 'Holiday Expenses',
  'savingsGoalTypes.savingsHolidayGoal.image': '/classpath/assets/images/icon-holiday.svg',
  'savingsGoalTypes.savingsHolidayGoal.title': 'Holiday Expenses',
  'savingsGoalTypes.savingsRetirementGoal': 'Retirement',
  'savingsGoalTypes.savingsRetirementGoal.image': '/classpath/assets/images/icon-retirement.svg',
  'savingsGoalTypes.savingsRetirementGoal.title': 'Retirement',
  'savingsGoalTypes.savingsOtherGoal': 'Other',
  'savingsGoalTypes.savingsOtherGoal.image': '/classpath/assets/images/icon-other.svg',
  'savingsGoalTypes.savingsOtherGoal.title': 'Other',

  /* DEPOSIT Question 2.4.1 - unexpected expense */
  'savingsUnexpectedGoal.cardBuilder.title': 'Emergency / Unexpected Expense',
  'savingsUnexpectedGoal.cardBuilder.body': '/classpath/assets/images/icon-check.svg',
  'savingsUnexpectedGoalAmount': 'How much do you need?',
  'details.savingsUnexpectedGoalAmount': `Goals: Unexpected expense | ${ amountToBorrow }`,
  'savingsUnexpectedGoalAmountSaved': 'How much have you saved?',
  'details.savingsUnexpectedGoalAmountSaved': `Goals: Unexpected expense | ${ amountSaved }`,

  'savingsUnexpectedGoalAmount.cardBuilder.answerLabel': howMuch,
  'savingsUnexpectedGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,

  /* DEPOSIT Question 2.4.2 - major purchase */
  'savingsMajorGoal.cardBuilder.title': 'Major purchase / Vacation / Education',
  'savingsMajorGoal.cardBuilder.body': '/classpath/assets/images/icon-check.svg',
  'savingsMajorGoalAmount': 'How much do you need?',
  'details.savingsMajorGoalAmount': `Goals: Major purchase | ${ amountToBorrow }`,
  'savingsMajorGoalAmountSaved': 'How much have you saved?',
  'details.savingsMajorGoalAmountSaved': `Goals: Major purchase | ${ amountSaved }`,
  'savingsMajorGoalAccess': 'When will you access your money?',
  'savingsMajorGoalAccess.weekly': 'Weekly',
  'savingsMajorGoalAccess.monthly': 'Monthly',
  'savingsMajorGoalAccess.quarterly': 'Quarterly',
  'savingsMajorGoalAccess.yearly': 'Yearly',
  'savingsMajorGoalAccess.yearlyPlus': '> Year',
  'savingsMajorGoalAmount.cardBuilder.answerLabel': howMuch,
  'savingsMajorGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,
  'savingsMajorGoalAccess.cardBuilder.answerLabel': access,

  /* DEPOSIT Question 2.4.3 - holiday */
  'savingsHolidayGoal.cardBuilder.title': 'Holiday Expenses',
  'savingsHolidayGoal.cardBuilder.body': '/classpath/assets/images/icon-check.svg',
  'savingsHolidayGoalAmount': 'How much do you need?',
  'details.savingsHolidayGoalAmount': `Goals: Holiday Expenses | ${ amountToBorrow }`,
  'savingsHolidayGoalAmountSaved': 'How much have you saved?',
  'details.savingsHolidayGoalAmountSaved': `Goals: Holiday Expenses | ${ amountSaved }`,
  'savingsHolidayGoalAccess': 'When will you access your money?',
  'savingsHolidayGoalAccess.weekly': 'Weekly',
  'savingsHolidayGoalAccess.monthly': 'Monthly',
  'savingsHolidayGoalAccess.quarterly': 'Quarterly',
  'savingsHolidayGoalAccess.yearly': 'Yearly',
  'savingsHolidayGoalAccess.yearlyPlus': '> Year',
  'savingsHolidayGoalAmount.cardBuilder.answerLabel': howMuch,
  'savingsHolidayGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,
  'savingsHolidayGoalAccess.cardBuilder.answerLabel': access,

  /* DEPOSIT Question 2.4.4 - retirement */
  'savingsRetirementGoal.cardBuilder.title': 'Retirement',
  'savingsRetirementGoal.cardBuilder.body': '/classpath/assets/images/icon-check.svg',
  'savingsRetirementGoalAmount': 'How much do you need?',
  'details.savingsRetirementGoalAmount': `Goals: Retirement | ${ amountToBorrow }`,
  'savingsRetirementGoalAmountSaved': 'How much have you saved?',
  'details.savingsRetirementGoalAmountSaved': `Goals: Retirement | ${ amountSaved }`,
  'savingsRetirementGoalAccess': 'When will you access your money?',
  'savingsRetirementGoalAccess.weekly': 'Weekly',
  'savingsRetirementGoalAccess.monthly': 'Monthly',
  'savingsRetirementGoalAccess.quarterly': 'Quarterly',
  'savingsRetirementGoalAccess.yearly': 'Yearly',
  'savingsRetirementGoalAccess.yearlyPlus': '> Year',
  'savingsRetirementGoalAmount.cardBuilder.answerLabel': howMuch,
  'savingsRetirementGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,
  'savingsRetirementGoalAccess.cardBuilder.answerLabel': access,


  /* DEPOSIT Question 2.4.5 - other */
  'savingsOtherGoal.cardBuilder.title': 'General Savings',
  'savingsOtherGoal.cardBuilder.body': '/classpath/assets/images/icon-savings.svg',
  'savingsOtherGoalAmount': 'How much do you need?',
  'details.savingsOtherGoalAmount': `Goals: General Savings | ${ amountToBorrow }`,
  'savingsOtherGoalAmountSaved': 'How much have you saved?',
  'details.savingsOtherGoalAmountSaved': `Goals: General Savings | ${ amountSaved }`,
  'savingsOtherGoalAccess': 'When will you access your money?',
  'savingsOtherGoalAccess.weekly': 'Weekly',
  'savingsOtherGoalAccess.monthly': 'Monthly',
  'savingsOtherGoalAccess.quarterly': 'Quarterly',
  'savingsOtherGoalAccess.yearly': 'Yearly',
  'savingsOtherGoalAccess.yearlyPlus': '> Year',
  'savingsOtherGoalAmount.cardBuilder.answerLabel': howMuch,
  'savingsOtherGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,
  'savingsOtherGoalAccess.cardBuilder.answerLabel': access,

  /* DEPOSIT Question 2.5 */
  'accessToFunds': 'You stated that you may not need access to your funds for a year or more. For this type of account do you prefer a fixed or variable rate?',
  'accessToFunds.tooltip': 'A fixed rate loan makes it easy to plan your budget because both the interest rate and the monthly payment will remain the same, plus you can calculate the total amount of interest you will pay over the life of the loan. For many people, fixed rates are best for long term loans (e.g. 15 years or more) because it is more likely interest rates could go up over longer periods of time. A variable rate loan typically has a lower starting rate than a fixed rate option. Keep in mind though, that a variable rate option means that your interest rate and therefore your monthly payment, can change over time to be higher or lower as defined in your loan agreement. For most people, variable rate loans make more sense for shorter term borrowing needs when you anticipate paying off or refinancing the loan before the rate can adjust. When considering a variable rate loan make sure you understand when and how payments will adjust per your loan agreement.',
  'accessToFunds.fixed': 'Fixed Rate',
  'accessToFunds.variable': 'Variable Rate',

  /* BORROW Question 4.9 */
  'reviewDepositPath': 'Can we now cover your deposit account needs?',
  'reviewDepositPath.true': 'Yes',
  'reviewDepositPath.false': 'No',

  'bankingExperience': "Thank you for sharing! Now we'd like to learn a little about your banking experience to match you with the right account.",
  'bankingExperience.new': "I'm new to banking and opening my first account",
  'bankingExperience.challenges': "I've had some challenges with banking and want a fresh start",
  'bankingExperience.experienced': "I have banking experience and am looking for the right fit",
};
